(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('ApplicationsFranchiserListController', ApplicationsFranchiserListController)

    /** @ngInject */
    function ApplicationsFranchiserListController(ApplicationService, ApplicationTypeService, HelperService, sweetAlert) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;

        vm.isSearchDisabled = () => {
            if (vm.selectedType || (vm.selectedSearchField && vm.searchText))
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedType || vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedType = null;
            vm.selectedSearchField = null;
            vm.searchText = null;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getApplications(start, number, tableState);
        }

        init();

        function getApplications(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            ApplicationService
                .getByParameters(parameters)
                .then(success => {
                    vm.applications = success.Applications;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.units = null;
                    vm.isLoading = false;
                    HelperService.errorCallback(error);
                })
        }

        function getApplicationTypes() {
            HelperService.startLoading('.custom-filters');

            ApplicationTypeService
                .getAll()
                .then(success => {
                    vm.applicationTypes = success;

                    HelperService.stopLoading('.custom-filters');
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'Title',
                OrderDescending: false
            }

            if (vm.selectedType)
                params.ApplicationTypeId = vm.selectedType.Id;

            if (tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText) {
                params.SearchField = vm.selectedSearchField.Description;
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function init() {
            vm.selectedType;
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = true;

            vm.searchFields = [{
                Value: 'Title',
                Description: 'Nome ou Descrição'
            }];

            getApplicationTypes();
        }
    }
}());